import { Routes, Route } from 'react-router';
import Infohub from './pages/Infohub';
import HsCode from './pages/HsCode';
import NavBar from './components/Navbar';
import Home from './pages/Home/Home';
import Determination from './pages/Determination/Determination';
import Verification from './pages/Verification/Verification';
import AdminPage from './pages/Admin/Admin';
import './App.css';

function App() {
  return (
    <>
      <NavBar />
      <Routes>
        <Route path='infohub' element={<Infohub />} />
        <Route path='determination' element={<Determination />} />
        <Route path='admin' element={<AdminPage />} />
        <Route path='hscode' element={<HsCode />} />
        <Route path='/verification' element={<Verification />} />
        <Route path='/' element={<Home />} />
      </Routes>
    </>
  );
}

export default App;
